export default function LazyImage({ src, className, placeholder, style, title, alt }) {
  return (
    <img
      src={src ?? placeholder}
      className={className}
      loading="lazy"
      style={style}
      title={title}
      alt={alt}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        if (placeholder) {
          currentTarget.src = placeholder;
        }
      }}
    />
  );
}
